/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, EffectFade, Parallax, A11y, Autoplay} from 'swiper/modules';

(($) => {

    //MAIN HERO SLIDESHOW
    const mainSwiper = new Swiper('.js-home-slideshow', {
        modules: [EffectFade,Navigation,Parallax,A11y,Autoplay],
        //effect: 'fade',
        speed: 1000,
        loop: true,
        parallax: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });

    // //INTERIOR GALLERY w/ THUMBNAILS
    const galleries = document.querySelectorAll('.gallery');

    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.js-gallery-slides');
        let prev = gallery.querySelector('.swiper-button-prev');
        let next = gallery.querySelector('.swiper-button-next');

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y],
            spaceBetween: 16,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            navigation: {
                prevEl: prev,
                nextEl: next
            }
        });

    });
    

})(jQuery)